/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import EmptySpaceFieldValid from "./EmptySpaceFieldValid";
import { Button, OverlayTrigger, Tooltip, Form, Image, DropdownButton, Dropdown } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { updateOrderManagementFilter } from "../../redux/actions/adminActions";
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from "../../assets/img/table_search_box.png";
import Select, { components } from 'react-select';
import CommonExport from "./CommonExport";
import ThreeMonthsDatepicker from "./ThreeMonthsDatepicker";
import BrowserUniqueTabID from "./BrowserUniqueTabID";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import { toast } from "react-toastify";
import OrderDraftRenewOrProceedAPI from "../../Api/OrderDraftRenewOrProceedAPI";

const MainOrderDataTableFilter = ({ tabName, filterType, searchType, ButtonSet, searchdisable, buttonvisible, FromDateStartDateFlag, AllOrderStatusAllow, isAllowWarehouse, isAllowProduct, isDateType, isOdiFilterAllow, isRegionAllow, isBundleOrdersAllow, isOrderSourceAllow, isPreBookFilterAllow, isSelectCheckBox, selectedOrderList, APIcalling, setLoader, ...props }) => {
    const [ CommonSearchUpdate, setCommonSearchUpdate ] = useState("");
    const {
      OrderManagmentFilter,
      Regionlistall,
      wareHouselistall,
      productlistall,
      device_id,
      accessToken,
    } = useSelector((state) => state.adminReducers);
    const optionsWarehouse = wareHouselistall?.filter((elm) => elm?.is_active === true)?.map((item, index) => ({ key: item.id, value: item?.id, label: `${item?.warehouse_name} - (${item?.warehouse_code})- (${item?.display_name})` }));``
    const optionsProduct = productlistall?.filter((elm) => elm?.is_active === true)?.map((item, index) => ({ key: item.id, value: item?.id, label: `${item?.product_name}` }));
    const [ show, setShow ] = useState(false);
    const Dispatch = useDispatch();

    var tabID = BrowserUniqueTabID();
    const { websocket } = useContext(WebSocketContext);

    const optionODI_Courier_Pin_Order = [
        {label:"All Orders", flag: "all", color: "#fff"},
        {label:"ODA Pincode", flag: "is_odi", color: "rgba(245, 133, 133, 0.32)"},
        {label:"Normal Pincode", flag: "is_normal", color: "#eee"},
        {label:"Serviceability missing", flag: "is_courier_pin_code", color: "#f3b70285"},
    ];

    const customMultiStyles = {
        option: (provided, state) => ({
          ...provided,
          fontSize: '13px', // Adjust the font size as per your requirement
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }),
        multiValue: (provided) => ({
            ...provided,
            fontSize: '13px',  // Set your desired font size here
            maxWidth: 100,  // Adjust the width as needed
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            fontSize: '13px',  // Set the font size of the label inside each selected tag
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            fontSize: '13px',  // Set the font size of the remove icon if needed
        }),
        valueContainer: (base) => ({
            ...base,
            overflow: "auto",
            maxHeight: "62px"
        }),
    };

    // select limit
    const SelectLimitFct = (e, url) => {
        const filterKey = url;
        if (filterKey) {
            Dispatch(updateOrderManagementFilter({
                [filterKey]: {
                    UserLimit: e.target.value,
                    CurrentPage: 1,
                }
            }));
        };
    };

    // clear search box
    const ClearSearchFiled = (url) => {
        const filterKey = url;

        if (filterKey) {
            Dispatch(updateOrderManagementFilter({
                [filterKey]: {
                    UserSearch: "",
                }
            }));
        };
    };

    // clear after delete button hit
    document.addEventListener('keydown', function(event) {
        var keyPressed = event.key;
        if (keyPressed === 'Delete') {
            ClearSearchFiled(tabName);
        }
    });

    // common search update state
    const SearchMainOnchange = async (value, url) => {
        if(url === tabName) {
            await setCommonSearchUpdate(value);
        };
    };

    // on enter search 
    const onEnterSearch = (e, url) => {
        const code = e.which || e.keyCode;
        if(code === 13) {
            const filterKey = tabName;

            if (filterKey) {
                OnEnterSearch(url);
            };
        };
    };

    // search box
    const OnEnterSearch = (url) => {
        const filterKey = url;

        if (filterKey) {
            Dispatch(updateOrderManagementFilter({
                [filterKey]: {
                    UserSearch: CommonSearchUpdate,
                    CurrentPage: 1,
                }
            }));
        };
    };    

    useEffect(() => {
        const CurrentSearch = OrderManagmentFilter[tabName]?.UserSearch === undefined ? "" : OrderManagmentFilter[tabName]?.UserSearch;
        setCommonSearchUpdate(CurrentSearch);
    }, [ OrderManagmentFilter[tabName] ]);

    const selectRegionFunction = (e, url) => {
        Dispatch(updateOrderManagementFilter({
            [url]: {
                SelectRegion: e.target.value,
                CurrentPage: 1,
            }
        }));
    };

    // pre-book filter update
    const OnChangePreBookFilter = (value, url) => {
        if (url) {
            Dispatch(updateOrderManagementFilter({
                [url]: {
                    PreBookFilter: value,
                    CurrentPage: 1,
                }
            }));
        };
    };

    // order Source update
    const OnChangeOrderSource = (value, url) => {
        if (url) {
            Dispatch(updateOrderManagementFilter({
                [url]: {
                    OrderSource: value,
                    CurrentPage: 1,
                }
            }));
        };
    };

    // select date type
    const selectDateTypeFunction = (e, url) => {
        Dispatch(updateOrderManagementFilter({
            [url]: {
                SelectDateType: e.target.value,
                CurrentPage: 1,
            }
        }));
    };

    // get page limit from redux
    const GetuserLimit = () => {
        if(OrderManagmentFilter[tabName]?.UserLimit === undefined) {
            return 10;
        } else {
            return OrderManagmentFilter[tabName].UserLimit;
        };
    };

    // order Source update
    const OnChangeBundleOrder = (event, url) => {
        const filterKey = url;

        if (filterKey) {
            Dispatch(updateOrderManagementFilter({
                [filterKey]: {
                    is_bundle_orders: event?.target?.checked,
                    CurrentPage: 1,
                }
            }));
        };
    };

    const OnChangeSelectCheckBox = (event, url) => {
      const filterKey = url;

      if (filterKey) {
        Dispatch(
          updateOrderManagementFilter({
            [filterKey]: {
              is_select_checkbox: event?.target?.checked,
              CurrentPage: 1,
            },
          }),
        );
      }
    };

    // wareehouse select
    const WareHouseSelect = (value, url) => {
        if(value !== null) {
            Dispatch(updateOrderManagementFilter({
                [url]: {
                    WarehouseName: value,
                    CurrentPage: 1,
                }
            }));
        } else {
            Dispatch(updateOrderManagementFilter({
                [url]: {
                    WarehouseName: "",
                    CurrentPage: 1,
                }
            }));
        };
    };

    // product select
    const ProductSelect = (value, url) => {
        if(value !== null) {
            Dispatch(updateOrderManagementFilter({
                [url]: {
                    ProductName: value,
                    CurrentPage: 1,
                }
            }));
        } else {
            Dispatch(updateOrderManagementFilter({
                [url]: {
                    ProductName: "",
                    CurrentPage: 1,
                }
            }));
        };
    };

    // ODI courier pincode select
    const OnChangeIsODICourierPincode = (value, url) => {
        if(url) {
            Dispatch(updateOrderManagementFilter({
                [url]: {
                    is_odi_courier_pin: value,
                    CurrentPage: 1,
                }
            }));
        };
    };

    const selectOrderTypeFunction = (e, url) => {
        Dispatch(updateOrderManagementFilter({
            [url]: {
                SelectOrderType: e.target.value,
                CurrentPage: 1,
            }
        }));
    };

    // reset filters
    const ResetFilters = (url) => {
        Dispatch(updateOrderManagementFilter({
            [url]: {
                WarehouseName: "",
                ProductName: "",
                CurrentPage: 1,
            }
        }));
    };

    // Custom Option with title on hover
    const CustomOption = (props) => {
        return (
            <components.Option {...props}>
                <div title={props.label} style={{ whiteSpace: "break-spaces" }}>{props.label}</div>
            </components.Option>
        );
    };

    // Custom MultiValueLabel with title for selected tags
    const CustomMultiValueLabel = (props) => {
        return (
            <components.MultiValueLabel {...props}>
                <span title={props.data.label} >{props.data.label}</span>
            </components.MultiValueLabel>
        );
    };

    const handleToggle = (isOpen) => {
        setShow(isOpen);
    };

    const handleClose = () => {
        setShow(false);
    };

    const count = (OrderManagmentFilter?.[tabName]?.ProductName?.length ? 1 : 0) + (OrderManagmentFilter?.[tabName]?.WarehouseName?.length ? 1 : 0);
    const message = count > 0 ? `✅ There ${count > 1 ? "are" : "is"} ${count} filter${count > 1 ? "s" : ""} selected. Click this button to open ${count > 1 ? "them" : "it"}.` : "🚫 No filters selected.";  

    const OrderDraftRenew = async () => {
      try {
        setLoader(true)
        let payload = {
          order_ids: selectedOrderList,
          action: "renew",
        };

        const response = await OrderDraftRenewOrProceedAPI(
          payload,
          accessToken,
        );

        if (response.status !== 200) {
          setLoader(false)
          toast.error(response.message);
        } else {
          setLoader(false)
          toast.info(response.message);
          if (APIcalling) APIcalling();
        }
      } catch (error) {
        setLoader(false)
        toast.error("Error sending order to renew stage", error.message);
      }
    };

    const OrderDraftProceed = async () => {
      try {
        setLoader(true)
        let payload = {
          order_ids: selectedOrderList,
          action: "proceed",
        };

        const response = await OrderDraftRenewOrProceedAPI(
          payload,
          accessToken,
        );

        if (response.status !== 200) {
          setLoader(false)
          toast.error(response.message);
        } else {
          setLoader(false)
          toast.info(response.message);
          if (APIcalling) APIcalling();
        }
      } catch (error) {
        setLoader(false)
        toast.error("Error sending order to renew stage", error.message);
      }
    };

    // const OrderDraftReject = async () => {
    //   const param = {
    //     transmit: "broadcast",
    //     url: "order_cancelled",
    //     request: {
    //       order_ids: selectedOrderList,
    //       cancel_reason: "rejected from franchise draft orders",
    //       order_status: "REJECTED",
    //     },
    //     DeviceId: device_id,
    //     TabId: tabID,
    //   };
    //   wsSend_request(websocket, param);

    //   if (APIcalling) APIcalling();
    // };

    const isBetween25And31IST = () => {
      const now = new Date();

      // Convert current time to IST
      const istTime = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
      );

      const day = istTime.getDate();
      return day >= 25 && day <= 31;
    };

    return (
      <div className="card-header-Order-Filter-New" style={{ width: "100%" }}>
        <div
          className="filtr_Form"
          style={{
            paddingBottom: "10px",
            borderBottom: "1px solid #eee",
            marginBottom: "10px",
          }}
        >
          <div className="formloginset">
            <div className="row">
              {/* DATE TYPE SELECT DROPDOWN */}
              {isDateType && (
                <div
                  className="col-md-2"
                  style={{ width: "14%", paddingRight: "0px" }}
                >
                  <div className="order_type_select">
                    <small>Date Type:</small>
                    <select
                      className="form-control activestatusselet pe-4"
                      id="columnfullwith"
                      value={
                        OrderManagmentFilter[tabName]?.SelectDateType ??
                        "created_at"
                      }
                      onChange={(e) => selectDateTypeFunction(e, tabName)}
                    >
                      <option value="created_at">Order Date</option>
                      <option value="updated_at">Updated Date</option>
                    </select>
                  </div>
                </div>
              )}

              {FromDateStartDateFlag && (
                <ThreeMonthsDatepicker tabName={tabName} />
              )}

              {/* ORDER STEPS FILTERS  */}
              {AllOrderStatusAllow && (
                <div
                  className="col-md-3"
                  style={{ width: "17%", paddingRight: "0px" }}
                >
                  <select
                    className="form-control activestatusselet pe-4"
                    id="columnfullwith"
                    value={
                      OrderManagmentFilter[tabName]?.SelectOrderType ===
                      undefined
                        ? tabName !== "DraftOrdersReport"
                          ? "OPEN,SO_HALF_APPROVAL,SO_APPROVED,WH_PENDING,WH_APPROVED,AC_APPROVED,ST_APPROVED,HALF_DISPATCH,DISPATCHED,DELIVERED,CANCELLED,REJECTED,RETURN,REPLACE,RETURN_REQUEST,PARTIALLY_RETURN,CANCELLED_REQUEST,REPLACE_REQUEST,PARTIALLY_REPLACE,DRAFT,RENEW"
                          : "DRAFT,RENEW"
                        : OrderManagmentFilter[tabName]?.SelectOrderType
                    }
                    onChange={(e) => selectOrderTypeFunction(e, tabName)}
                  >
                    {tabName !== "DraftOrdersReport" ? (
                      <>
                        <option value="OPEN,SO_HALF_APPROVAL,SO_APPROVED,WH_PENDING,WH_APPROVED,AC_APPROVED,ST_APPROVED,HALF_DISPATCH,DISPATCHED,DELIVERED,CANCELLED,REJECTED,RETURN,REPLACE,RETURN_REQUEST,PARTIALLY_RETURN,CANCELLED_REQUEST,REPLACE_REQUEST,PARTIALLY_REPLACE,DRAFT,RENEW">
                          All
                        </option>
                        <option value="DRAFT">Draft</option>
                        <option value="RENEW">Renew</option>
                        <option value="OPEN,SO_HALF_APPROVAL">
                          So Approval
                        </option>
                        <option value="SO_APPROVED">Warehouse Approval</option>
                        <option value="WH_PENDING">Warehouse Pending</option>
                        <option value="AC_APPROVED,WH_APPROVED">
                          Pending For Store
                        </option>
                        <option value="ST_APPROVED,HALF_DISPATCH">
                          Pending For Dispatch
                        </option>
                        <option value="DISPATCHED">Pending For Delivery</option>
                        <option value="DELIVERED">Order Delivered</option>
                        <option value="REJECTED">Rejected</option>
                        <option value="CANCELLED,CANCELLED_REQUEST">
                          Cancellation
                        </option>
                        <option value="RETURN,REPLACE,RETURN_REQUEST,RETURN_IN_TRANSIT,REPLACE_REQUEST,PARTIALLY_RETURN">
                          Return And Replace
                        </option>
                        <option value="UC_UPCOMING">Upcoming Orders</option>
                      </>
                    ) : (
                      <>
                        <option value="DRAFT,RENEW">All</option>
                        <option value="DRAFT">Draft</option>
                        <option value="RENEW">Renew</option>
                      </>
                    )}
                  </select>
                </div>
              )}

              {/* SELECT REGION */}
              {isRegionAllow && (
                <div
                  className="col-md-3"
                  style={{ width: "13%", paddingRight: "0px" }}
                >
                  <select
                    className="form-control activestatusselet pe-4"
                    id="columnfullwith"
                    value={OrderManagmentFilter[tabName]?.SelectRegion}
                    onChange={(e) => selectRegionFunction(e, tabName)}
                  >
                    <option value="">Select Region</option>
                    {Regionlistall?.filter((elz) => elz?.is_active)?.map(
                      (elm, index) => {
                        return (
                          <option value={elm?.id} key={index}>
                            {elm?.region_name}
                          </option>
                        );
                      },
                    )}
                  </select>
                </div>
              )}

              {/* EXPORT BUTTON */}
              <div
                className="col-md-3"
                style={{ width: "auto", paddingRight: "0px" }}
              >
                <button
                  className="btn exportbtn"
                  id="exportbtn"
                  disabled={
                    OrderManagmentFilter[tabName]?.ToDate === "" ||
                    OrderManagmentFilter[tabName]?.FromDate === ""
                  }
                  style={{ width: "auto", marginRight: "0px" }}
                  onClick={() =>
                    CommonExport("order_list", {
                      FromDate: OrderManagmentFilter[tabName]?.FromDate,
                      ToDate: OrderManagmentFilter[tabName]?.ToDate,
                      FromInv: null,
                      ToInv: null,
                      status:
                        OrderManagmentFilter[tabName]?.SelectOrderType ===
                        undefined
                          ? ""
                          : OrderManagmentFilter[tabName]?.SelectOrderType,
                      region_id: OrderManagmentFilter[tabName]?.SelectRegion,
                      search: OrderManagmentFilter[tabName]?.UserSearch.trim(),
                      order_type: OrderManagmentFilter[tabName]?.orderSource,
                    })
                  }
                >
                  <i className="bi bi-filetype-xlsx"></i>
                  Export
                </button>
              </div>

              {isAllowWarehouse && isAllowProduct && (
                <div
                  className="col-md-2 filter_dropdwon_main"
                  style={{
                    textAlign: "right",
                    position: "absolute",
                    right: "0px",
                    top: "0px",
                  }}
                >
                  <Dropdown show={show} onToggle={handleToggle}>
                    <OverlayTrigger
                      placement="left"
                      delay={{ show: 250, hide: 100 }}
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="button-tooltip"
                          {...props}
                        >
                          {message}
                        </Tooltip>
                      }
                    >
                      <Dropdown.Toggle
                        variant="primary"
                        id="dropdown-basic"
                        className={
                          OrderManagmentFilter[tabName]?.ProductName?.length >
                            0 ||
                          OrderManagmentFilter[tabName]?.WarehouseName?.length >
                            0
                            ? "custom_filter_drop active_dropdown"
                            : "custom_filter_drop"
                        }
                      >
                        <span className="badge">
                          {OrderManagmentFilter[tabName]?.ProductName?.length >
                            0 &&
                          OrderManagmentFilter[tabName]?.WarehouseName?.length >
                            0
                            ? 2
                            : OrderManagmentFilter[tabName]?.ProductName
                                  ?.length > 0
                              ? 1
                              : OrderManagmentFilter[tabName]?.WarehouseName
                                    ?.length > 0
                                ? 1
                                : 0}
                        </span>
                        More Filters
                      </Dropdown.Toggle>
                    </OverlayTrigger>
                    <Dropdown.Menu>
                      <Dropdown.ItemText>
                        <div className="filter_dropdonw_main">
                          {isAllowWarehouse && (
                            <Form.Group className="mb-3">
                              <Form.Label>Select Warehouse:</Form.Label>
                              <div
                                className="selectMultiselect selectMultiselectBrand"
                                id="selectMultiselectBrand"
                              >
                                <Select
                                  value={
                                    OrderManagmentFilter[tabName]?.WarehouseName
                                  }
                                  onChange={(e) => WareHouseSelect(e, tabName)}
                                  isClearable
                                  options={optionsWarehouse}
                                  className="godown-select-container"
                                  classNamePrefix="godown-select"
                                  placeholder="Select Warehouse"
                                  components={{
                                    Option: CustomOption,
                                    MultiValueLabel: CustomMultiValueLabel,
                                  }}
                                  styles={customMultiStyles}
                                  isMulti
                                />
                              </div>
                            </Form.Group>
                          )}

                          {isAllowProduct && (
                            <Form.Group className="mb-3">
                              <Form.Label>Select Product:</Form.Label>
                              <div
                                className="selectMultiselect selectMultiselectBrand"
                                id="selectMultiselectBrand"
                              >
                                <Select
                                  value={
                                    OrderManagmentFilter[tabName]?.ProductName
                                  }
                                  onChange={(e) => ProductSelect(e, tabName)}
                                  isClearable
                                  options={optionsProduct}
                                  className="godown-select-container"
                                  classNamePrefix="godown-select"
                                  placeholder="Select Product"
                                  components={{
                                    Option: CustomOption,
                                    MultiValueLabel: CustomMultiValueLabel,
                                  }}
                                  styles={customMultiStyles}
                                  isMulti
                                />
                              </div>
                            </Form.Group>
                          )}
                          <Form.Group style={{ float: "left", width: "100%" }}>
                            <div style={{ display: "flex", columnGap: "7px" }}>
                              <button className="btn" onClick={handleClose}>
                                Close
                              </button>
                              <button
                                className="btn"
                                id="PurchaseOrderClearbtn"
                                onClick={() => ResetFilters(tabName)}
                              >
                                Reset Filter
                              </button>
                            </div>
                          </Form.Group>
                        </div>
                      </Dropdown.ItemText>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="card-header-New">
          {/* TABLE LISTING SEARCH */}
          {isSelectCheckBox && (
            <div className="order_bunddle_checkboxes d-flex align-items-end pe-4">
              <Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={OrderManagmentFilter[tabName]?.is_select_checkbox}
                  onChange={(e) => OnChangeSelectCheckBox(e, tabName)}
                />
                Select Orders
              </Form.Label>
            </div>
          )}
          {searchdisable && (
            <div
              className={`searchBoxwithbtn ${
                CommonSearchUpdate !== "" ? "search" : ""
              }`}
            >
              <input
                type="text"
                className="form-control"
                value={CommonSearchUpdate}
                onKeyDown={(e) => {
                  onEnterSearch(e, tabName);
                  EmptySpaceFieldValid(e);
                }}
                onChange={(e) => SearchMainOnchange(e.target.value, tabName)}
                placeholder={`Search ...`}
              />
              <Button
                className="searchbtn"
                onClick={() => OnEnterSearch(tabName)}
              >
                <Image src={SearchIcon} alt="search_btn" />
              </Button>
              {CommonSearchUpdate !== "" && (
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 100 }}
                  overlay={
                    <Tooltip
                      style={{ position: "fixed" }}
                      id="button-tooltip"
                      {...props}
                    >
                      Clear the search by using the delete key.
                    </Tooltip>
                  }
                >
                  <i
                    className="bi bi-x-circle-fill searchclear"
                    onClick={() => ClearSearchFiled(tabName)}
                  ></i>
                </OverlayTrigger>
              )}

              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 100 }}
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="button-tooltip"
                    {...props}
                  >
                    Search using {searchType ? `(${searchType})` : ""}
                  </Tooltip>
                }
              >
                <i className="searchInfo bi bi-info-circle-fill"></i>
              </OverlayTrigger>
            </div>
          )}
          <div className="card-header-right">
            {selectedOrderList?.length > 0 && (
              <div className="d-flex px-3" style={{ gap: "0.9em" }}>
                <Button
                  variant="outline-success"
                  onClick={OrderDraftProceed}
                  style={{ fontSize: "0.9em" }}
                >
                  Proceed
                </Button>
                {/* <Button
                  variant="outline-danger"
                  onClick={OrderDraftReject}
                  style={{ fontSize: "0.9em" }}
                >
                  Reject
                </Button> */}
                <Button
                  variant={`${isBetween25And31IST() ? "outline-dark" : "dark"}`}
                  disabled={!isBetween25And31IST()}
                  onClick={OrderDraftRenew}
                  style={{ fontSize: "0.9em" }}
                >
                  Renew
                </Button>
              </div>
            )}
            {/* BUNDLE ORDER CHECKBOX */}
            {isBundleOrdersAllow && (
              <div className="order_bunddle_checkboxes">
                <Form.Label>
                  <Form.Check
                    type="checkbox"
                    checked={OrderManagmentFilter[tabName]?.is_bundle_orders}
                    onChange={(e) => OnChangeBundleOrder(e, tabName)}
                  />
                  Bundle Orders
                </Form.Label>
              </div>
            )}

            {/* ODI COURIER PIN ORDER SELECT */}
            {isOdiFilterAllow && (
              <div className="order_bunddle_seelct order_ODA_bunddle_seelct">
                <DropdownButton
                  id="dropdown-basic-button"
                  className={
                    "order_bunlde_active_ ODA_order_active_" +
                    (OrderManagmentFilter[tabName]?.is_odi_courier_pin ===
                    undefined
                      ? optionODI_Courier_Pin_Order[0]?.label?.replaceAll(
                          " ",
                          "_",
                        )
                      : OrderManagmentFilter[
                          tabName
                        ]?.is_odi_courier_pin?.label?.replaceAll(" ", "_"))
                  }
                  title={
                    OrderManagmentFilter[tabName]?.is_odi_courier_pin ===
                    undefined
                      ? optionODI_Courier_Pin_Order[0]?.label
                      : OrderManagmentFilter[tabName]?.is_odi_courier_pin?.label
                  }
                >
                  {optionODI_Courier_Pin_Order?.map((elm, index) => {
                    return (
                      <Dropdown.Item
                        className={elm.label?.replaceAll(" ", "_")}
                        key={index}
                        onClick={() =>
                          OnChangeIsODICourierPincode(elm, tabName)
                        }
                      >
                        <span
                          style={{
                            backgroundColor:
                              elm?.label === "All Orders"
                                ? "#eee"
                                : `${elm?.color}`,
                          }}
                        ></span>
                        {elm?.label}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </div>
            )}

            {/* PRE-BOOK ORDER FILTER SELECT */}
            {isPreBookFilterAllow && (
              <select
                className="form-control activestatusselet pe-4"
                id="FranchiseUserReportWidthNew"
                value={OrderManagmentFilter[tabName]?.PreBookFilter ?? ""}
                onChange={(e) => OnChangePreBookFilter(e.target.value, tabName)}
              >
                <option value="">All Orders</option>
                <option value="true">Pre-Book Orders</option>
                <option value="false">Non Pre-Book Orders</option>
              </select>
            )}

            {/* ORDER SOURCE SELECT */}
            {isOrderSourceAllow && (
              <select
                className="form-control activestatusselet pe-4"
                id="FranchiseUserReportWidthNew"
                value={OrderManagmentFilter[tabName]?.OrderSource}
                onChange={(e) => OnChangeOrderSource(e.target.value, tabName)}
              >
                <option value="">All</option>
                <option value="FO">Dealer</option>
                <option value="CO">Sale</option>
                <option value="WO"> Internal Warehouse to Warehouse</option>
                <option value="AO">Amazon, Website, Flipkart</option>
              </select>
            )}

            {/* SELECT TABLE LIMIT */}
            <select
              className="form-control userLimitselect"
              value={GetuserLimit()}
              onChange={(e) => SelectLimitFct(e, tabName)}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="60">60</option>
              <option value="70">70</option>
              <option value="80">80</option>
              <option value="90">90</option>
              <option value="100">100</option>
            </select>

            {/* COMMON BUTTON */}
            {buttonvisible && (
              <button
                className="btn head_cmn_btn"
                style={{ marginLeft: filterType === "Users" ? "10px" : "0px" }}
                onClick={ButtonSet?.function}
              >
                <i
                  className={
                    ButtonSet?.buttontitle === "Return & Replace"
                      ? "bi bi-arrow-return-right"
                      : "bi bi-plus-circle"
                  }
                ></i>
                {ButtonSet?.buttontitle}
              </button>
            )}
          </div>
        </div>
      </div>
    );
}

export default MainOrderDataTableFilter;